var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.controls.drawer)?_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();_vm.controls.drawer = !_vm.controls.drawer}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }